var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { COMPONENT_OUTLINE_BORDER } from "../theme/componentBorders";
import { Input, Button, Empty, List, Checkbox, Typography, Modal, } from "antd";
import { LeftOutlined, RightOutlined, SaveOutlined, } from "@ant-design/icons";
var Search = Input.Search;
var Text = Typography.Text;
/**
 * 通用穿梭框模态框组件
 */
var GenericModalTransfer = function (_a) {
    var 
    // 模态框属性
    _b = _a.visible, 
    // 模态框属性
    visible = _b === void 0 ? false : _b, _c = _a.title, title = _c === void 0 ? "选择数据" : _c, _d = _a.width, width = _d === void 0 ? 900 : _d, onCancel = _a.onCancel, onOk = _a.onOk, _e = _a.okText, okText = _e === void 0 ? "确定" : _e, _f = _a.cancelText, cancelText = _f === void 0 ? "取消" : _f, okButtonProps = _a.okButtonProps, cancelButtonProps = _a.cancelButtonProps, 
    // 穿梭框属性
    _g = _a.sourceTitle, 
    // 穿梭框属性
    sourceTitle = _g === void 0 ? "可选列表" : _g, _h = _a.targetTitle, targetTitle = _h === void 0 ? "已选列表" : _h, _j = _a.sourceData, sourceData = _j === void 0 ? [] : _j, _k = _a.targetData, targetData = _k === void 0 ? [] : _k, _l = _a.loading, loading = _l === void 0 ? false : _l, _m = _a.saveLoading, saveLoading = _m === void 0 ? false : _m, _o = _a.showSearch, showSearch = _o === void 0 ? true : _o, _p = _a.height, height = _p === void 0 ? 500 : _p, 
    // 回调函数
    onChange = _a.onChange, onSave = _a.onSave, onRefresh = _a.onRefresh, _q = _a.disabled, disabled = _q === void 0 ? false : _q;
    // 状态定义
    var _r = useState(""), leftSearchValue = _r[0], setLeftSearchValue = _r[1];
    var _s = useState(""), rightSearchValue = _s[0], setRightSearchValue = _s[1];
    var _t = useState(sourceData), filteredSourceData = _t[0], setFilteredSourceData = _t[1];
    var _u = useState(targetData), filteredTargetData = _u[0], setFilteredTargetData = _u[1];
    var _v = useState([]), selectedSourceIds = _v[0], setSelectedSourceIds = _v[1];
    var _w = useState([]), selectedTargetIds = _w[0], setSelectedTargetIds = _w[1];
    var _x = useState(targetData), internalTargetData = _x[0], setInternalTargetData = _x[1];
    // 当源数据变化时，更新过滤后的源数据
    useEffect(function () {
        filterSourceData(leftSearchValue);
    }, [sourceData, internalTargetData]);
    // 当目标数据变化时，更新过滤后的目标数据
    useEffect(function () {
        filterTargetData(rightSearchValue);
    }, [internalTargetData]);
    // 当外部传入的目标数据变化时，更新内部目标数据
    useEffect(function () {
        setInternalTargetData(targetData);
    }, [targetData]);
    // 处理左侧搜索
    var handleLeftSearch = function (value) {
        setLeftSearchValue(value);
        filterSourceData(value);
    };
    // 处理右侧搜索
    var handleRightSearch = function (value) {
        setRightSearchValue(value);
        filterTargetData(value);
    };
    // 过滤源数据
    var filterSourceData = function (value) {
        // 排除已在目标列表中的项
        var targetIds = internalTargetData.map(function (item) { return item.id; });
        var availableSourceData = sourceData.filter(function (item) { return !targetIds.includes(item.id); });
        if (!value) {
            setFilteredSourceData(availableSourceData);
            return;
        }
        var filtered = availableSourceData.filter(function (item) {
            return item.title.toLowerCase().includes(value.toLowerCase()) ||
                (item.description &&
                    item.description.toLowerCase().includes(value.toLowerCase()));
        });
        setFilteredSourceData(filtered);
    };
    // 过滤目标数据
    var filterTargetData = function (value) {
        if (!value) {
            setFilteredTargetData(internalTargetData);
            return;
        }
        var filtered = internalTargetData.filter(function (item) {
            return item.title.toLowerCase().includes(value.toLowerCase()) ||
                (item.description &&
                    item.description.toLowerCase().includes(value.toLowerCase()));
        });
        setFilteredTargetData(filtered);
    };
    // 处理向右传送（从源到目标）
    var handleMoveToRight = function () {
        if (selectedSourceIds.length === 0 || disabled)
            return;
        // 找到选中的源项
        var selectedItems = sourceData.filter(function (item) {
            return selectedSourceIds.includes(item.id);
        });
        // 更新内部目标数据
        var newTargetData = __spreadArray(__spreadArray([], internalTargetData, true), selectedItems, true);
        setInternalTargetData(newTargetData);
        // 清除源选择
        setSelectedSourceIds([]);
        // 触发回调
        if (onChange) {
            onChange(newTargetData);
        }
    };
    // 处理向左传送（从目标到源）
    var handleMoveToLeft = function () {
        if (selectedTargetIds.length === 0 || disabled)
            return;
        // 更新内部目标数据，移除选中项
        var newTargetData = internalTargetData.filter(function (item) { return !selectedTargetIds.includes(item.id); });
        setInternalTargetData(newTargetData);
        // 清除目标选择
        setSelectedTargetIds([]);
        // 触发回调
        if (onChange) {
            onChange(newTargetData);
        }
    };
    // 处理源项选择
    var handleSourceSelect = function (itemId, checked) {
        if (disabled)
            return;
        if (checked) {
            setSelectedSourceIds(function (prev) { return __spreadArray(__spreadArray([], prev, true), [itemId], false); });
        }
        else {
            setSelectedSourceIds(function (prev) {
                return prev.filter(function (id) { return id !== itemId; });
            });
        }
    };
    // 处理目标项选择
    var handleTargetSelect = function (itemId, checked) {
        if (disabled)
            return;
        if (checked) {
            setSelectedTargetIds(function (prev) { return __spreadArray(__spreadArray([], prev, true), [itemId], false); });
        }
        else {
            setSelectedTargetIds(function (prev) {
                return prev.filter(function (id) { return id !== itemId; });
            });
        }
    };
    // 处理保存按钮点击
    var handleSave = function () {
        if (onSave) {
            onSave(internalTargetData);
        }
        else if (onOk) {
            onOk();
        }
    };
    // 渲染列表项
    var renderListItem = function (item, isSource) {
        var selected = isSource
            ? selectedSourceIds.includes(item.id)
            : selectedTargetIds.includes(item.id);
        return (_jsxs(List.Item, __assign({ style: {
                padding: "8px 0",
                cursor: disabled ? "not-allowed" : "default",
                opacity: disabled ? 0.6 : 1,
            } }, { children: [_jsx(Checkbox, { checked: selected, disabled: disabled || item.disabled, onChange: function (e) {
                        if (isSource) {
                            handleSourceSelect(item.id, e.target.checked);
                        }
                        else {
                            handleTargetSelect(item.id, e.target.checked);
                        }
                    }, style: { marginRight: 8 } }), _jsxs("div", __assign({ style: { flex: 1 } }, { children: [_jsx("div", __assign({ style: { fontWeight: 500 } }, { children: item.title })), item.description && (_jsx("div", __assign({ style: { fontSize: "12px", color: "#999" } }, { children: item.description })))] }))] }), item.id));
    };
    // 定义模态框底部按钮
    var modalFooter = [
        _jsx(Button, __assign({ onClick: onCancel }, cancelButtonProps, { children: cancelText }), "cancel"),
        _jsx(Button, __assign({ type: "primary", icon: _jsx(SaveOutlined, {}), loading: saveLoading, onClick: handleSave, disabled: disabled }, okButtonProps, { children: okText }), "save"),
    ];
    // 修改内容部分的宽度布局
    // 在 return 语句中，修改最外层容器的样式
    return (_jsx(Modal, __assign({ title: title, open: visible, onCancel: onCancel, width: width, footer: modalFooter, destroyOnClose: true, maskClosable: false, styles: {
            body: {
                padding: "20px",
                overflow: "auto", // 确保内容过长时可以滚动
            },
        } }, { children: _jsx("div", __assign({ style: {
                display: "flex",
                height: typeof height === "number" ? "".concat(height, "px") : height,
                width: "100%",
                justifyContent: "center", // 水平居中内容
            } }, { children: _jsxs("div", __assign({ style: {
                    display: "flex",
                    width: "100%",
                    maxWidth: "800px", // 限制内容最大宽度
                } }, { children: [_jsxs("div", __assign({ style: {
                            flex: 7,
                            display: "flex",
                            flexDirection: "column",
                            marginRight: 8,
                        } }, { children: [_jsx("div", __assign({ style: { fontWeight: 500, marginBottom: 8 } }, { children: sourceTitle })), showSearch && (_jsx(Search, { placeholder: "\u641C\u7D22...", allowClear: true, value: leftSearchValue, onChange: function (e) { return handleLeftSearch(e.target.value); }, style: { marginBottom: 8 }, disabled: disabled })), _jsx("div", __assign({ style: {
                                    flex: 1,
                                    overflow: "auto",
                                    border: COMPONENT_OUTLINE_BORDER,
                                    borderRadius: 4,
                                    padding: "0 8px",
                                } }, { children: filteredSourceData.length > 0 ? (_jsx(List, { dataSource: filteredSourceData, renderItem: function (item) { return renderListItem(item, true); }, size: "small" })) : (_jsx(Empty, { description: "\u6682\u65E0\u6570\u636E", style: { margin: "40px 0" } })) })), _jsx("div", __assign({ style: { marginTop: 8 } }, { children: _jsx(Text, __assign({ type: "secondary" }, { children: "".concat(selectedSourceIds.length, " \u9879\u5DF2\u9009 / \u5171 ").concat(filteredSourceData.length, " \u9879") })) }))] })), _jsxs("div", __assign({ style: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            padding: "0 12px",
                            width: "50px",
                        } }, { children: [_jsx(Button, { type: "primary", icon: _jsx(RightOutlined, {}), disabled: selectedSourceIds.length === 0 || disabled, onClick: handleMoveToRight, style: { marginBottom: 12 } }), _jsx(Button, { type: "primary", icon: _jsx(LeftOutlined, {}), disabled: selectedTargetIds.length === 0 || disabled, onClick: handleMoveToLeft })] })), _jsxs("div", __assign({ style: {
                            flex: 7,
                            display: "flex",
                            flexDirection: "column",
                            marginLeft: 8,
                        } }, { children: [_jsx("div", __assign({ style: { fontWeight: 500, marginBottom: 8 } }, { children: targetTitle })), showSearch && (_jsx(Search, { placeholder: "\u641C\u7D22...", allowClear: true, value: rightSearchValue, onChange: function (e) { return handleRightSearch(e.target.value); }, style: { marginBottom: 8 }, disabled: disabled })), _jsx("div", __assign({ style: {
                                    flex: 1,
                                    overflow: "auto",
                                    border: COMPONENT_OUTLINE_BORDER,
                                    borderRadius: 4,
                                    padding: "0 8px",
                                } }, { children: filteredTargetData.length > 0 ? (_jsx(List, { dataSource: filteredTargetData, renderItem: function (item) { return renderListItem(item, false); }, size: "small" })) : (_jsx(Empty, { description: "\u6682\u65E0\u6570\u636E", style: { margin: "40px 0" } })) })), _jsx("div", __assign({ style: { marginTop: 8 } }, { children: _jsx(Text, __assign({ type: "secondary" }, { children: "".concat(selectedTargetIds.length, " \u9879\u5DF2\u9009 / \u5171 ").concat(filteredTargetData.length, " \u9879") })) }))] }))] })) })) })));
};
export default GenericModalTransfer;
